// extracted by mini-css-extract-plugin
module.exports = {"countryName":"CountryName_countryName__J2MsH"};